import Loadable from "react-loadable";

// For chunk splitting
const loadableProps = {
  timeout: 60 * 1000,
};
const Loading = () => null;

const Index = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "index" */ "@/pages/Index/Index"),
  loading: Loading,
});

const Find = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Find" */ "@/pages/Supplier"),
  loading: Loading,
});

const Incoming = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Incoming" */ "@/pages/Apparatus"),
  loading: Loading,
});

const Sample = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Sample" */ "@/pages/Sample"),
  loading: Loading,
});

const SendEmail = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "SendEmail" */ "@/pages/SendEmail"),
  loading: Loading,
});

const ScriptLibrary = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "ScriptLibrary" */ "@/pages/ScriptLibrary"),
  loading: Loading,
});

const Score = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Score" */ "@/pages/Score"),
  loading: Loading,
});

const ScoreConfig = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Score" */ "@/pages/Score/ScoreConfig"),
  loading: Loading,
});

const ScoreDeploy = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Score" */ "@/pages/Score/ScoreDeploy"),
  loading: Loading,
});

const ShopList = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Score" */ "@/pages/ShopManagement/ShopList"),
  loading: Loading,
});

const Help = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Help" */ "@/pages/More/Help"),
  loading: Loading,
});

const Package = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Package" */ "@/pages/Package/Package"),
  loading: Loading,
});

const OrderList = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "OrderList" */ "@/pages/OrderManagement/OrderList"
    ),
  loading: Loading,
});

const Raidsys = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Raidsys" */ "@/pages/Search/Raidsys"),
  loading: Loading,
});

const List = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "List" */ "@/pages/Apparatus/List"),
  loading: Loading,
});

const Messages = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Messages" */ "@/pages/UserGroup/Messages"),
  loading: Loading,
});

const Status = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Status" */ "@/pages/UserGroup/Status"),
  loading: Loading,
});

const Checklist = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Checklist" */ "@/pages/Checklist"),
  loading: Loading,
});

const userGroup = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "userGroup" */ "@/pages/UserGroup"),
  loading: Loading,
});

const Viral = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Viral" */ "@/pages/Viral"),
  loading: Loading,
});

const Script = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Script" */ "@/pages/Viral/Script"),
  loading: Loading,
});

const Video = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Video" */ "@/pages/Viral/Video"),
  loading: Loading,
});

const Asset = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Asset" */ "@/pages/Viral/Asset"),
  loading: Loading,
});

const TikTokPublish = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "TikTokPublish" */ "@/pages/Viral/TikTokPublish"
    ),
  loading: Loading,
});

const Analytics = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Analytics" */ "@/pages/UserGroup/Analytics"),
  loading: Loading,
});

const SubAccounts = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "SubAccounts" */ "@/pages/ShopManagement/SubAccounts"
    ),
  loading: Loading,
});

const ContentCreation = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "SubAccounts" */ "@/pages/Viral/ContentCreation"
    ),
  loading: Loading,
});

// Sub system component map
const subSystemMap = {
  Index,
  Find,
  Incoming,
  Sample,
  SendEmail,
  ScriptLibrary,
  Score,
  ScoreConfig,
  ScoreDeploy,
  ShopList,
  Help,
  Package,
  OrderList,
  Raidsys,
  List,
  Status,
  Checklist,
  userGroup,
  Messages,
  Analytics,
  Viral,
  Script,
  Video,
  Asset,
  TikTokPublish,
  SubAccounts,
  ContentCreation,
};

export { subSystemMap };
